import { PaymentMethod, UserI } from "@/types/base";

export const HIDDEN_CARD_MASK = "●●●";

export const getSavedPaymentMethods = (user: UserI | null): PaymentMethod[] =>
  user?.saved_payment_methods ?? [];

export const getCardLastNumbers = (last4?: string | null) =>
  last4 ? ` ${last4}` : "●";
